import { useEffect, useState } from "react";
import { NegocioConfig } from "../../configuracion/Empresa";
import { useLocalStorage } from "../storage/useLocalStorage";
import { UsuarioContext } from "./UsuarioContext";
import { IdentificarEstacion } from "../../componentes/estacion/Estacion";

const UsuarioState = (props) => {
    const [usuario, setUsuario] = useLocalStorage("usuario_almacenado" + NegocioConfig.sistema, null);
    const [token, setToken] = useLocalStorage("toke_almacenado" + NegocioConfig.sistema, null);
    const [estacion, setEstacion] = useLocalStorage("estacion" + NegocioConfig.sistema, null);

    const [carritoCotizacion, setCarritoCotizacion] = useState(() => {
        const storedCart = localStorage.getItem("carritoCotizacionAressa");
        return storedCart ? JSON.parse(storedCart) : [];
    });

    const [carritoPedidos, setCarritoPedidos] = useState(() => {
        const storedOrders = localStorage.getItem("carritoPedidosAressa");
        return storedOrders ? JSON.parse(storedOrders) : [];
    });

    useEffect(() => {
        localStorage.setItem("carritoCotizacionAressa", JSON.stringify(carritoCotizacion));
    }, [carritoCotizacion]);

    useEffect(() => {
        localStorage.setItem("carritoPedidosAressa", JSON.stringify(carritoPedidos));
    }, [carritoPedidos]);

    const setCerrarSesion = () => {
        setUsuario(null);
        setToken(null);
        setCarritoCotizacion([]);
        setCarritoPedidos([]);
        localStorage.removeItem("carritoCotizacionAressa");
        localStorage.removeItem("carritoPedidoAressa");
    };

    const setLogin = async (data) => {
        try {
            setUsuario(data.usuario);
            setToken(data.token);
        } catch (error) {
            console.log(error);
        }
    };

    const agregarProductoAlCarrito = (producto) => {
        setCarritoPedidos((prev) => {
            const existe = prev.find((item) => item.id === producto.id);
            if (existe) {
                return prev.map((item) =>
                    item.id === producto.id
                        ? { ...item, cantidad: (item.cantidad || 1) + 1 }
                        : item
                );
            }
            return [...prev, { ...producto, cantidad: 1 }];
        });
    };

    const agregarCotizacionAlCarrito = (producto) => {
        setCarritoCotizacion((prev) => {
            const existe = prev.find((item) => item.id === producto.id);
            if (existe) {
                return prev.map((item) =>
                    item.id === producto.id
                        ? { ...item, cantidad: (item.cantidad || 1) + 1 }
                        : item
                );
            }
            return [...prev, { ...producto, cantidad: 1 }];
        });
    };

    const vaciarCarritoCotizacion = () => {
        setCarritoCotizacion([]);
        localStorage.removeItem("carritoCotizacionAressa");
    };

    const vaciarCarritoPedidos = () => {
        setCarritoPedidos([]);
        localStorage.removeItem("carritoPedidosAressa");
    };

    return (
        <UsuarioContext.Provider
            value={{
                usuario,
                token,
                carritoPedidos,
                carritoCotizacion,
                estacion,
                setLogin,
                setCerrarSesion,
                setCarritoCotizacion,
                setCarritoPedidos,
                agregarProductoAlCarrito,
                agregarCotizacionAlCarrito,
                vaciarCarritoCotizacion,
                vaciarCarritoPedidos,
                setEstacion,
            }}
        >
            {props.children}
        </UsuarioContext.Provider>
    );
};

export default UsuarioState;
